import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';
import ReactGA from 'react-ga';

class MyLearningPath extends Component{
    constructor(props) {
        super(props)
        this.state = {
            data:{
                pageStatus: ''
            }
        }
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)
        let accessCheck = 'user/learning_resource/mc_learning_path'

        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview('/learning_resources_home');

        return api.getUserResponse(this.props.user.accessToken, accessCheck)
        .then((result) => {
            data.pageStatus = result.status
            this.setState({data: data})
        })


        /*
        <br />
            <ListItem>
                <ListItemGraphic>feedback</ListItemGraphic>
                <ListItemText><Link to="/portal/app/user/survey_user_home">Survey</Link> <br /><Typography use="caption">Let us know your thoughts!</Typography> </ListItemText>
            </ListItem> 
            <ListItem>
                <ListItemGraphic>assignment</ListItemGraphic>
                <ListItemText><Link to="/portal/app/user/my_learning_path/my_strength_and_development_areas">My Strengths and Development Areas</Link> <br /><Typography use="caption">Mark competencies as strength areas or development areas and access related resources.</Typography></ListItemText>
            </ListItem>
            <br />
            <ListItem>
                <ListItemGraphic>how_to_vote</ListItemGraphic>
                <ListItemText><Link to="/portal/app/user/my_learning_path/my_archives_section">My Archives</Link> <br /><Typography use="caption">Resources marked for future reference.</Typography> </ListItemText>
            </ListItem>
            <br />
        */

    }

    render(){
        let mainPageContent
        if (this.state.data.pageStatus === 'version_2') {
            mainPageContent = (
                <Grid>
                    <GridCell span = "12">
                        <Card style={{padding: '0px'}}>
                            <Grid className="opportunity-list-item">
                                <GridCell span = "11">
                                    <Typography use="headline5">My Learning Plan</Typography>
                                </GridCell>
                            </Grid>
                        </Card>
                    </GridCell>
                    <GridCell span = "12">
                    <Typography use="subtitle2">Click on the link below to view multiple sections of your learning path.</Typography>
                    <List>
                        <ListItem>
                            <ListItemGraphic>map</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/learning_resources">Build My Learning Plan</Link> <br /><Typography use="caption">Access learning resources mapped to CENTA Standards and build your learning plan.</Typography></ListItemText>
                        </ListItem>
                        <br />
                        <ListItem>
                            <ListItemGraphic>bookmarks</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/my_learning_path/my_bookmarks_section">My Learning Plan</Link> <br /><Typography use="caption">View and manage your personalized learning plan.</Typography></ListItemText>
                        </ListItem>
                        <br />
                        <ListItem>
                            <ListItemGraphic>send</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/upload_resource">Contribute a Resource</Link> <br /><Typography use="caption">Submit a resource which you would want to contribute to MyCENTA Learning Resources. We will get back to you after review.</Typography> </ListItemText>
                        </ListItem>
                    </List>
                    </GridCell>
                </Grid>
            )
        }
        else if (this.state.data.pageStatus === 'version_1') {
            mainPageContent = (
                <Grid>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5">My Learning Plan</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span = "12">
                    <br />
                    <Typography use="subtitle2">Click on the link below to proceed the learning resource.</Typography>
                    <List>
                        <ListItem>
                            <ListItemGraphic>map</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/all_mc_roadmaps">Micro-Credentials Learning Resources </Link></ListItemText>
                        </ListItem>
                        <ListItem>
                            <ListItemGraphic>merge_type</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/my_learning_arc_section">My Learning Path</Link></ListItemText>
                        </ListItem>
                    </List>
                    </GridCell>
                </Grid>
            )
        }
        else if (this.state.data.pageStatus === 'no_access'){
            mainPageContent = (
                <Grid>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5">My Learning Plan</Typography>
                        </Card>
                    </GridCell>
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="subtitle2">You will be able to access this section in the coming days.</Typography>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }
        return(
            <div>
                {mainPageContent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLearningPath);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/MyLearningPath.jsx